// src/Home.js
import React, { useEffect, useState } from "react";
import "./Home.css";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom"; 
export default function Home() {
  const [heroImages, setHeroImages] = useState([
    "https://m.media-amazon.com/images/I/71POqHTHB7L.jpg",
    "https://media.istockphoto.com/id/1856117770/photo/modern-beauty-salon.jpg?s=612x612&w=0&k=20&c=dVZtsePk2pgbqDXwVkMm-yIw5imnZ2rnkAruR7zf8EA=",
    "https://colorlib.com/wp/wp-content/uploads/sites/2/jevelin-spa-salon-wordpress-beauty-theme.jpg",
    "https://d2dfxqxblmblx4.cloudfront.net/wp-content/uploads/2015/10/18151211/Salon-Slogan-Ideas-2.jpg"
  ]);
  const navigate = useNavigate();
  const [currentImage, setCurrentImage] = useState(0);
 const [menuOpen, setMenuOpen] = useState(false); 
  // 🔄 Auto Slide Hero Background
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % heroImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [heroImages.length]);

  // 🔄 Fade animation for scroll
  useEffect(() => {
    const fadeSections = document.querySelectorAll(".fade-section");
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.2 }
    );
    fadeSections.forEach(section => observer.observe(section));
    return () => observer.disconnect();
  }, []);


  return (
    <div className="home-page">
      {/* ===== Navbar ===== */}
<nav className="navbar">
      {/* Logo */}
      <div className="logo">
        <img src="/logos.jpg" alt="Beauty Salon Logo" />
      </div>

      {/* Search Box */}
      <div className="search-box">
        <input type="text" placeholder="Search..." />
      </div>

      {/* Hamburger for Mobile */}
      <div
        className={`hamburger ${menuOpen ? "active" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Nav Links */}
      <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
        <li><Link to="/" onClick={() => setMenuOpen(false)}>Home</Link></li>
        <li><Link to="/services" onClick={() => setMenuOpen(false)}>Services</Link></li>
        <li><Link to="/about" onClick={() => setMenuOpen(false)}>About</Link></li>
        <li><Link to="/gallery" onClick={() => setMenuOpen(false)}>Gallery</Link></li>
        <li><Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link></li>
      </ul>



      {/* Book Now Button */}
      <Link to="/booking" className="book-btn">Book Now</Link>
    </nav>


      {/* ===== Hero Section (Auto Sliding Background) ===== */}
      <section id="home" className="hero-section fade-section">
        {heroImages.map((img, index) => (
          <div
            key={index}
            className={`hero-bg ${index === currentImage ? "active" : ""}`}
            style={{ backgroundImage: `url(${img})` }}
          ></div>
        ))}

        <div className="hero-overlay"></div>

        <div className="hero-content">
          <h1 className="hero-title">Be Bold. Be Beautiful. Be You.</h1>
          <p className="hero-subtitle">
            Transform your style with our luxury salon experience.
          </p>
         <button
        className="hero-btn"
        onClick={() => navigate("/services")}
      >
        Explore Services
      </button>
        </div>
      </section>

      {/* ===== Services Section ===== */}
     <section id="services" className="services fade-section">
  <h2 className="section-title">Our Premium Services</h2>
  <div className="service-grid">
    <div className="service-card">
      <img src="https://productimages.withfloats.com/serviceimages/tile/65d9cd0620316e5adb61d417Hairstyle-services-at-home" alt="Hair Styling" />
      <h3>Hair Styling</h3>
      <p>Modern cuts, colors & treatments that enhance your personality.</p>
    </div>
    <div className="service-card">
      <img src="data:image/jpeg;base64,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" alt="Facial & Spa" />
      <h3>Facial & Spa</h3>
      <p>Relax & rejuvenate your skin with luxury facial & spa therapy.</p>
    </div>
    <div className="service-card">
      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTMlrdRnE56kno498L74PUGWPbJLHn5-Fd8fw&s" alt="Makeup" />
      <h3>Professional Makeup</h3>
      <p>Flawless looks for weddings, shoots & special events.</p>
    </div>
    <div className="service-card">
      <img src="https://images-static.naikaa.com/beauty-blog/wp-content/uploads/2024/07/nair-art-design-13.jpg" alt="Nail Art" />
      <h3>Nail Art & Extension</h3>
      <p>Trendy nail art & durable gel extensions with vibrant styles.</p>
    </div>

    <div className="service-card">
      <img src="https://www.flipbodyspa.in/images/about-flip-body-spa-gurgaon-1.webp" alt="Massage" />
      <h3>Body Massage</h3>
      <p>Experience ultimate relaxation & stress relief with our therapy.</p>
    </div>
    <div className="service-card">
      <img src="https://prityskincare.co.uk/wp-content/uploads/2025/01/Benefits-of-Threading-or-Waxing-for-Eyebrows-770x428.webp" alt="Waxing" />
      <h3>Waxing & Threading</h3>
      <p>Smooth, gentle, and professional — feel fresh & confident.</p>
    </div>
    <div className="service-card">
      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRgNyec9xX5WkE5_2j9lKFzPuUk5Rz2R4W-cA&s" alt="Hair Spa" />
      <h3>Hair Spa & Treatment</h3>
      <p>Revitalize your hair with deep nourishment & shine therapy.</p>
    </div>
    <div className="service-card">
      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRY9MhFHZ1tPuvK6m31TPKv_v840r91EiEZ8Q&s" alt="Bridal Package" />
      <h3>Bridal Packages</h3>
      <p>Complete beauty care for your big day — makeup to styling.</p>
    </div>
    <div className="service-card">
      <img src="https://cureskin.com/wp-content/uploads/2021/06/AdobeStock_358942388-1024x760.jpeg" alt="Bridal Package" />
      <h3>Clean up</h3>
      <p>Complete beauty care for your big day — makeup to styling.</p>
    </div>
  </div>
</section>

      {/* ===== About Section ===== */}
   <section id="about" className="about fade-section">
  <div className="about-content">
    <h2>About Us</h2>
    <p>
      At Glamour Studio, we believe beauty is confidence. Our expert
      stylists and beauticians offer a luxurious, relaxing experience that
      enhances your natural glow. With top-quality products and modern
      techniques, we promise to bring out the best version of you.
    </p>
    <button className="about-btn">Learn More</button>
  </div>
  <div className="about-image">
    <img src="https://img.freepik.com/free-photo/side-view-professional-doing-bridal-makeup-look_23-2149722043.jpg?semt=ais_hybrid&w=740&q=80" alt="About Glamour Studio" />
  </div>
</section>

{/* ====== Salon Showcase Section ====== */}
{/* ====== Full Page Horizontal Slider ====== */}
<section className="fullpage-slider fade-section">
  <div className="slider-track">
    {[
      "https://www.radiustheme.com/wp-content/uploads/2020/10/Scissors-Salon-1024x683.jpg",
      "https://salonbizsoftware.com/wp-content/uploads/2024/02/Stylists-doing-hair-at-salon-stations.jpg",
      "https://m.media-amazon.com/images/I/81NF4ZMndrL.jpg",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRxWMlgfivmUvNK4Ro0IG4T-KtYWuNJbhkzZQ&s",
      "https://t4.ftcdn.net/jpg/08/04/98/63/360_F_804986371_wNPY5g7AMn8v9fZVqviu8eOrBMNVVkAH.jpg"
    ].concat(
      ["https://www.radiustheme.com/wp-content/uploads/2020/10/Scissors-Salon-1024x683.jpg"] // duplicate first
    ).map((img, idx) => (
      <div key={idx} className="slider-item">
        <img src={img} alt={`Slide ${idx + 1}`} />
      </div>
    ))}
  </div>
  <div className="slider-dots">
    {[...Array(5)].map((_, idx) => (
      <span key={idx} className="dot"></span>
    ))}
  </div>
</section>



      {/* ===== Gallery Section ===== */}
      <section id="gallery" className="gallery fade-section">
        <h2 className="section-title">Salon Gallery</h2>
        <div className="gallery-grid">
          <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQLLRijU3869JRfBK3DoM-h40axWlO06FmyXg&s" alt="Salon 1" />
          <img src="https://www.shutterstock.com/image-photo/skincare-legs-woman-studio-closeup-600nw-2472681359.jpg" alt="Salon 2" />
          <img src="https://st2.depositphotos.com/8174188/11436/i/950/depositphotos_114365664-stock-photo-beautiful-female-feet-at-spa.jpg" alt="Salon 3" />
          <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSCkBvzqyC_jkeaZIKgqfFOSmBf5JSMByeWAeBDa7YxgyQ_Phf17rQhvdoS87HckPSw4b4&usqp=CAU" alt="Salon 4" />
          <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTt3FCOzzXk866znRNs8UBEUUnoNlNqrAlI4R9pGa8-BEyt4zrA7OVEjfd9VjbhH_FlTPo&usqp=CAU" alt="Salon 5" />
          <img src="https://cdn.citymapia.com/kochi/ole-salon-spa/23355/Portfolio.jpg?biz=5546" alt="Salon 6" />
          
        </div>
      </section>
<section className="faq-section fade-section">
  <h2 className="section-title">Frequently Asked Questions</h2>
  <div className="faq-list">
    {[
      {
        question: "How can I book salon at home?",
        answer: "You can book our home salon services through our website or mobile app by selecting your preferred service and time slot."
      },
      {
        question: "Does HOME SALON offer all kinds of Beauty Salon services?",
        answer: "Yes, we provide a wide range of beauty services including hair styling, facials, spa, makeup, threading, waxing, and more."
      },
      {
        question: "Do Home Salon beauticians bring their own beauty kit?",
        answer: "Yes, our professional beauticians carry all the necessary tools and products to provide a complete salon experience at your home."
      },
      {
        question: "Do Home Salon accept online payments?",
        answer: "Yes, we accept online payments through secure gateways for convenience and safety."
      },
      {
        question: "Do Home Salon service providers use original beauty products?",
        answer: "Absolutely! We only use authentic and high-quality beauty products from trusted brands."
      },
      {
        question: "Are your Home Salon beauticians reliable and professional?",
        answer: "Yes, all our beauticians are trained, verified, and experienced professionals."
      }
      // Add more Q&A as needed
    ].map((item, idx) => (
      <div key={idx} className="faq-item">
        <p className="faq-question">{item.question}</p>
        <p className="faq-answer">{item.answer}</p>
      </div>
    ))}
  </div>
</section>

      {/* ===== Contact Section ===== */}
      <section id="contact" className="contact fade-section">
        <h2 className="section-title">Book Your Appointment</h2>
        <p>Let’s bring your dream look to life!</p>
        <button className="book-btn large">Book Now</button>
      </section>

      {/* ===== Footer ===== */}
      <footer className="footer">
        <p>© 2025 Glamour Studio | Designed with 💅 by Beauty Experts</p>
      </footer>
    </div>
  );
}
